var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChrome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chrome SVG"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M63.9999 95.9858C81.673 95.9858 95.9999 81.659 95.9999 63.9858C95.9999 46.3127 81.673 31.9858 63.9999 31.9858C46.3268 31.9858 31.9999 46.3127 31.9999 63.9858C31.9999 81.659 46.3268 95.9858 63.9999 95.9858Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M64 32.0001H119.417C113.801 22.2705 105.723 14.1908 95.9943 8.57346C86.2657 2.95614 75.2296 -0.000783654 63.9958 1.55786e-07C52.7619 0.000783966 41.7262 2.95925 31.9984 8.57793C22.2706 14.1966 14.1936 22.2774 8.57947 32.0079L36.2877 80.0001L36.3125 79.9937C33.4939 75.1331 32.0064 69.6153 32.0001 63.9965C31.9938 58.3778 33.4688 52.8567 36.2766 47.9897C39.0843 43.1228 43.1255 39.0821 47.9927 36.2748C52.86 33.4676 58.3812 31.9932 64 32.0001Z",
    fill: "url(#paint0_linear_1935_20802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M64 89.3334C77.9912 89.3334 89.3333 77.9913 89.3333 64.0001C89.3333 50.0089 77.9912 38.6667 64 38.6667C50.0087 38.6667 38.6666 50.0089 38.6666 64.0001C38.6666 77.9913 50.0087 89.3334 64 89.3334Z",
    fill: "#1A73E8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M91.7101 80.0078L64.0018 128C75.2356 128.002 86.2719 125.045 96.0008 119.429C105.73 113.812 113.809 105.733 119.425 96.004C125.041 86.2748 127.997 75.2384 127.995 64.0046C127.993 52.7708 125.033 41.7355 119.413 32.0083H63.997L63.9904 32.0331C69.6091 32.0223 75.1314 33.4929 80.0006 36.2968C84.8698 39.1007 88.9138 43.1387 91.7248 48.0037C94.5358 52.8688 96.0146 58.3889 96.012 64.0077C96.0094 69.6265 94.5256 75.1453 91.7101 80.0078Z",
    fill: "url(#paint1_linear_1935_20802)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M36.2894 80.0084L8.58112 32.0161C2.96279 41.7441 0.00469116 52.7799 0.00427251 64.0137C0.00385385 75.2476 2.96113 86.2836 8.57874 96.012C14.1964 105.74 22.2763 113.818 32.0061 119.434C41.7359 125.049 52.7726 128.003 64.0065 128L91.7147 80.0078L91.6969 79.9897C88.8968 84.8611 84.8619 88.9082 79.9991 91.723C75.1363 94.5379 69.6173 96.021 63.9985 96.0229C58.3798 96.0248 52.8598 94.5454 47.995 91.7338C43.1303 88.9222 39.0928 84.8778 36.2894 80.0084Z",
    fill: "url(#paint2_linear_1935_20802)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1935_20802",
    x1: 8.57947,
    y1: 40.0001,
    x2: 119.417,
    y2: 40.0001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D93025"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EA4335"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1935_20802",
    x1: 55.2584,
    y1: 127.144,
    x2: 110.677,
    y2: 31.1566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCC934"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBBC04"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1935_20802",
    x1: 70.9281,
    y1: 124.004,
    x2: 15.5094,
    y2: 28.0161,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E8E3E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#34A853"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChrome);
export default __webpack_public_path__ + "static/media/chrome.59a930bc195357b0cd2ba7bd29791c68.svg";
export { ForwardRef as ReactComponent };